import DataTable from 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-fixedheader-bs5';

window.DataTable = DataTable;
window.Datatable = DataTable;
